export default __webpack_public_path__ + "static/10_29-7a797027993b2396cc4dc9356ce75a22.png";